export default __webpack_public_path__ + "static/media/City_Year.406ead6b.svg";